module.exports = __webpack_public_path__ + "img/palm0_1.b772b930.png";